<div class="sidebar-overlay">
</div>
<div class="sidebar-container overflow-hidden">
  <header class="px-6 my-5 sidebar-header">
    <h2 class="my-2">{{actionConfigMap[action]?.asideTitle}}</h2>
    <button type="button" id="close-sidepanel" class="close" aria-label="Close" (click)="closeSidePanel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </header>
  <div class="px-6 pb-8 mb-8 sidebar-content overflow-scroll">
    <div class="mt-7 cp-heading-box py-4">
      <div class="border-right">
        <h4 class="ff-thin">
          {{auctionDetails.name}} : {{auctionDetails.tentative_cap | SmartValuePipe : 'INR' }}
        </h4>
      </div>
      <div class="border-right">
        <div class="d-flex justify-content-start py-2 warning-text">
          <span>{{auctionDetails.completion_percentage | number:'1.0-2' }} % Done :</span> &nbsp;
          <span>
            {{(auctionDetails.tentative_cap * auctionDetails.completion_percentage / 100) | SmartValuePipe:'INR'}}
          </span>
        </div>
        <ngb-progressbar type="warning" [value]="auctionDetails.completion_percentage"></ngb-progressbar>
      </div>
      <div class="border-right">
        <div class="other-info-sec p-0">
          <ul class="d-flex justify-content-around">
            <li>
              <small> Value Date</small>
              <span>{{auctionDetails.tentative_value_date | StringToDateFormatPipe: '': 'default'}}</span>
            </li>
            <li>
              <small>Maturity Date</small>
              <span>{{auctionDetails.tentative_maturity_date | StringToDateFormatPipe: '': 'default'}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="mt-3">
        <div class="other-info-sec p-0">
          <ul class="d-flex justify-content-around align-items-center">
            <li>
              <small>RFQ Expires On</small>
              <span> {{auctionDetails.auction_expiry | StringToDateFormatPipe: 'addExpiry': 'default' }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div *ngIf="actionConfigMap[action]?.asideShowOtherBid">
      <h4 class="mt-8 mb-6 enabled-text">
        {{actionConfigMap[action]?.asideOtherHeader}}
      </h4>
      <div class="dark-bg-info-card px-4 py-4 my-4 d-flex justify-content-around">
        <div class="w-65 mx-4">
          <div class="row py-2 border-bottom">
            <small class="text-center col-2" *ngIf="!isInvestor"><b>Type</b></small>
            <small class="text-center col-{{isInvestor ? '3' : '2'}}"><b>Value</b></small>
            <small class="text-center col-{{isInvestor ? '3' : '2'}}"><b>Rate</b></small>
            <small class="text-center col-3"><b>Value Date</b></small>
            <small class="text-center col-3"><b>Maturity</b></small>
          </div>
          <div class="row py-3">
            <small class="text-center col-2 px-0" *ngIf="!isInvestor">{{bidThread.investor_line_of_business}}</small>
            <small class="text-center col-{{isInvestor ? '3' : '2'}} px-0">{{bidThread.bid[0].amount | SmartValuePipe
              :'INR'}}</small>
            <small class="text-center col-{{isInvestor ? '3' : '2'}}">{{bidThread.bid[0].roi | number:'1.0-3'
              }}%</small>
            <small class="text-center col-3">{{bidThread.bid[0].value_date | StringToDateFormatPipe: '':
              'default'}}</small>
            <small class="text-center col-3">{{bidThread.bid[0].maturity_date | StringToDateFormatPipe: '': 'default'}}
            </small>
          </div>
        </div>
        <div class="mx-4 text-center border-right">
          <div></div>
        </div>
        <div class="w-35 mx-4">
          <div class="row py-2 border-bottom">
            <small class="px-0 text-center col-12">
              <b>
                Quote Good Till
                <span class="for-icon-right for-clock"></span>
              </b>
            </small>
          </div>
          <div class="row py-3">
            <small class="px-0 text-center col-12">{{bidThread.bid[0].bid_expiry |
              StringToDateFormatPipe:'addExpiryTwoParts':'full_seconds' }}</small>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="action === PLACE_A_BID_ACTION">
      <h5 class="mt-8 mb-4">
        Quotes from other investors:
      </h5>
      <div class="bg-dark p-3 rounded">
        <div class="p-4 text-center small text-muted" *ngIf="otherInvestorBids.length === 0">
          Currently, there are no quotes from other investors.
        </div>
        <div class="row mx-0 py-2 border-bottom" *ngIf="otherInvestorBids.length > 0">
          <small class="text-center col-3"><b>Quote Value</b></small>
          <small class="text-center col-3"><b>Rate</b></small>
          <small class="text-center col-3"><b>Value Date</b></small>
          <small class="text-center col-3"><b>Maturity</b></small>
        </div>
        <div class="row mx-0 py-3" *ngFor="let otherBid of otherInvestorBids; let bidThreadIndex = index;">
          <ng-container *ngIf="otherInvestorBids">
            <small class="text-center col-3">{{otherBid.amount | SmartValuePipe : 'INR'}}</small>
            <small class="text-center col-3">{{otherBid.roi | number:'1.0-3' }}%</small>
            <small class="text-center col-3">{{otherBid.value_date | StringToDateFormatPipe: '': 'default'}}</small>
            <small class="text-center col-3">{{otherBid.maturity_date | StringToDateFormatPipe : '': 'default'}}</small>
          </ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="actionConfigMap[action]?.asideFormHeader">
      <h4 id="sidepanel-form-header" class="mt-8 mb-6 warning-text">{{actionConfigMap[action]?.asideFormHeader}}</h4>
      <app-bid-form [isInvestor]="isInvestor" [auctionDetails]="auctionDetails" [bidDetails]="bidThread?.bid[0]"
        [formAction]="action" (bidFormSubmitEvent)="onBidFormSubmit($event)">
      </app-bid-form>
    </div>

    <div *ngIf="!actionConfigMap[action]?.asideFormHeader" class="mt-9 d-flex justify-content-end align-items-stretch">
      <div class="w-50 btn btn-md text-center fs-18" [ngClass]=" 'btn-' + actionConfigMap[action]?.btnColorMod"
        [attr.id]="'bid-side-panel-' + action" (click)="handleBidAction(bidThread.bid[0].id, action)">
        {{actionConfigMap[action]?.asideTitle}}
      </div>
    </div>
  </div>
</div>